module.exports = __webpack_public_path__ + "e6d15b89ec1bd53975d1bc3223ee25c1.png";